/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_search': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 15.784',
    data: '<path pid="0" d="M15.621 13.577l-3.678-3.679a6.468 6.468 0 10-1.785 1.873l3.635 3.635a1.293 1.293 0 101.829-1.829zm-9.156-2.742a4.37 4.37 0 114.37-4.37 4.37 4.37 0 01-4.37 4.37z" data-name="Path 16877" _fill="#959ba6"/>'
  }
})
